import { parse } from 'date-fns/esm';

export const Defaults = {
  DURATION: 15,
  INTERVAL: 15,
  RELEASED_AT: parse('2021-04-01', 'yyyy-MM-dd', new Date()),
} as const;
